function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { isPromise } from './object';
export var isPropResolvedPromise = function isPropResolvedPromise(prop) {
  return isPromise(prop);
};
export var isPropPromiseFunction = function isPropPromiseFunction(prop) {
  return !isPromise(prop) && typeof prop === 'function';
};
export var resolvePromiseableProp = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(prop) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", isPropResolvedPromise(prop) ? prop.then() : isPropPromiseFunction(prop) ? prop() : prop);

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function resolvePromiseableProp(_x) {
    return _ref.apply(this, arguments);
  };
}();